/**
 * 错误处理服务钩子
 * 提供便捷访问错误处理服务的方法
 *
 * 核心功能：
 * 1. 获取错误处理上下文
 * 2. 提供类型安全的错误处理服务访问
 * 3. 确保在Provider内部使用
 */
import { useContext } from 'react';
import { ErrorContext } from '../contexts/ErrorContext.js';
/**
 * 使用错误处理服务钩子
 * 便于在组件中使用错误处理服务
 *
 * @returns 错误处理服务实例
 * @throws 如果在ErrorProvider外部使用则抛出错误
 *
 * @example
 * ```tsx
 * const errorHandler = useErrorHandler();
 *
 * // 捕获并处理错误
 * try {
 *   // 可能抛出错误的代码
 * } catch (error) {
 *   errorHandler.handleError('操作失败', error);
 * }
 * ```
 */
export function useErrorHandler() {
    const errorHandler = useContext(ErrorContext);
    if (errorHandler === null) {
        throw new Error('useErrorHandler must be used within an ErrorProvider');
    }
    return errorHandler;
}
/**
 * 默认导出钩子函数
 * 便于导入使用
 */
export default useErrorHandler;
//# sourceMappingURL=useErrorHandler.js.map